module.exports = __webpack_public_path__ + "img/icon_star_1.c71b882c.svg";